import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService, ITdDataTableColumn, TdDataTableSortingOrder, IPageChangeEvent, TdDataTableService, ITdDataTableSortChangeEvent, TdLoadingService } from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Piece } from '../../../inventory/piece';
import { InventoryService } from '../../../inventory/inventory.service';
import { PrintingService } from '../../../../shared/services/printing.service';
import { ProductService } from '../../../purchasing/products/product.service';
import { Product } from '../../../purchasing/products/product';
import { SettingsService } from '../../../../shared/services/settings.service';
import {Utils} from '../../../../shared/utils';

@Component({
  selector: 'app-print-roll-label',
  templateUrl: './print-roll-label.component.html',
  styleUrls: ['./print-roll-label.component.scss'],
  providers: [PrintingService]
})
export class PrintRollLabelComponent implements OnInit {
  pieceNumber: number;
  piece: Piece = new Piece();

  pieces: Piece[] = [];

  columns: ITdDataTableColumn[] = [
    { name: 'piece_number', label: 'Piece Number', tooltip: '' },
    { name: 'collection_name', label: 'Collection'},
    { name: 'design_name', label: 'Design'},
    { name: 'color_name', label: 'Color'},
    { name: 'branch', label: 'Branch' },
    { name: 'location_name', label: 'Location' }
  ];

  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  constructor(private _dialogService: TdDialogService,
    private _inventoryService: InventoryService,
    private _printService: PrintingService,
    private _dataTableService: TdDataTableService,
    public _settingsService: SettingsService,
    private _productService: ProductService,
    private location: Location,
    private _loadingService: TdLoadingService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this._loadingService.register('loading');

    this._inventoryService.getPieces().subscribe(
      (response: Piece[]) => {
        this.pieces = response;
        this.filter();
        this._loadingService.resolve('loading');
      },
      error => {
        this._loadingService.resolve('loading');
      }
    );
  }

  goBack(): void {
    this.location.back();
  }

  print(piece_id: number) {
    this._inventoryService.getPiece(piece_id, false).subscribe(
      (response: Piece[]) => {
        if (Array.isArray(response) && response.length > 0) {
          this.piece = response[0];

          // Fill in the gaps from the product view
          this._productService.getOneProduct(this.piece.color_id + '').subscribe(
            (product: Product) => {
              if (product != null) {
                this._printService.print(
                  {
                    company_name: 'Mystic', // Set in stone
                    collection: this.piece.collection_name,
                    design: this.piece.design_name,
                    part_number: this.piece.piece_number,
                    color: this.piece.color_name,
                    grade_cut: '',
                    lot_no: this.piece.lot_number,
                    meters: this.piece.length,
                    kilos: this.piece.weight,
                    composition: product.composition,
                    width: product.width,
                    weight: product.weight_gsm
                  }, this._authService.getPrinterId(), 1, 'roll').subscribe(
                  response => {
                    if (response['status'] == 'SUCCESS') {
                      this._dialogService.openAlert({
                        message: 'Sent to print queue!',
                        title: 'Success'
                      });
                    } else {
                      this._dialogService.openAlert({
                        message: 'Could not send to print queue!',
                        title: 'Failed'
                      });
                    }
                  }
                  );
              } else {
                this._dialogService.openAlert({
                  message: 'The product information could not be retrieved!',
                  title: 'Failed'
                });
              }
            }
          );
        } else {
          this._dialogService.openAlert({
            message: 'The roll information could not be found!',
            title: 'Failed'
          });
        }
      }
    );
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }
  
  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.pieces;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/print-roll-label/print-roll-label.component.ts